
import animation2dLib from './2dAnimation/list';
import modelLib from './model/list';
import actionLib from './action/list';
import audioLib from './audio/index.vue';
import handLib from './hand/index.vue';
import backgroundLib from './background/index.vue';
import sequenceFrameLib from './sequenceFrame/index.vue';
import buttonSkinLib from './buttonSkin/index.vue';
import leadRoleLib from './leadRole/index.vue';
import fontLib from './font/index.vue';
import musicLib from './music/index.vue';
import dialogLib from './dialog/index.vue';
import progressBarLib from './progressBar/index.vue';
import animationPreset from './animationPreset/index.vue';

export default {
  components: {
    animation2dLib: animation2dLib,
    modelLib: modelLib,
    actionLib: actionLib,
    audioLib: audioLib,
    handLib: handLib,
    backgroundLib: backgroundLib,
    sequenceFrameLib: sequenceFrameLib,
    buttonSkinLib: buttonSkinLib,
    leadRoleLib: leadRoleLib,
    fontLib: fontLib,
    musicLib: musicLib,
    dialogLib: dialogLib,
    progressBarLib: progressBarLib,
    animationPreset: animationPreset
  },
  data: function data() {
    return {
      tabMapOptions: [{ label: '模型库', value: 'model-list' }, { label: '动作库', value: 'action-list' }, { label: '2D动画库', value: '2d-animation-list' }, { label: '背景音乐库', value: 'audio-list' }, { label: '手指库', value: 'hand-list' }, { label: '背景图库', value: 'background-list' }, { label: '特效库', value: 'sequence-frame-list' }, { label: 'CTA按钮', value: 'button-skin-list' }, { label: '主角库', value: 'lead-role-list' }, { label: '字体库', value: 'font-list' }, { label: '对话框', value: 'dialog-list' }, { label: '进度条', value: 'progress-bar-list' }, { label: '音效库', value: 'music-list' }, { label: '动画预设', value: 'animation-preset-list' }],
      activeName: ''
    };
  },

  methods: {
    tabClickHandle: function tabClickHandle() {
      this.$router.push({ path: '/repo/itav-material/' + this.activeName });
    },
    getActiveName: function getActiveName() {
      var _this = this;

      // 路由中的meta.title与tab.label一致，所以可以以这个title做为判断
      return (this.tabMapOptions.find(function (item) {
        return item.label === _this.$route.meta.title;
      }) || {}).value;
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.activeName = this.getActiveName();
    }
  },
  mounted: function mounted() {
    this.activeName = this.getActiveName();
  }
};